/** 현재 공개 운영사 정보. 과거 거래·계약의 사업자 정보에는 사용하지 않는다. */
export const OPERATOR = {
  name: "주식회사 앤초비",
  representative: "이강욱",
  registrationNumber: "287-87-03788",
  address: "서울특별시 강남구 테헤란로6길 26, 3층 3139호(역삼동)",
  phone: "010-4456-0417",
  phoneHref: "tel:01044560417",
  email: "official.dangil@gmail.com",
  privacyOfficer: "이강욱",
  privacyOfficerTitle: "대표이사",
  policyEffectiveDate: "2026년 10월 8일",
  businessInfoUrl: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2878703788",
  // 앤초비의 통신판매업 신고번호는 확인 후 추가한다. 구 법인 번호를 재사용하지 않는다.
} as const;
